import styled from 'styled-components';

export const TabContent = styled.div`
  background-color: #ffffff;
  padding: 16px 32px;
  border-top: none;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.05);
  border-radius: 3px;

  > p {
    font-family: Hind, serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0;
    text-align: left;
    white-space: pre-wrap;
  }
`;

export const TabTermos = styled.div`
  display: flex;
  flex-direction: row;
  padding-bottom: 24px;

  input {
    cursor: pointer;
  }

  label {
    color: #656668;
    font-size: 12px;
    padding-left: 6px;
  }
`;

export const ButtonsTabs = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 24px;
  gap: 10px;
`;

export const Logo = styled.img`
  max-height: 40px;
  max-width: 100px;
  margin-bottom: 16px;
  margin-right: 16px;
`;
